module.exports = __webpack_public_path__ + "img/CM-EC-25-Lincoln-Lifestyle.b5d1a099.jpg";